import React, { Component } from 'react';

import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import DialogFactory from '../../factory/DialogFactory';
import CalendarSummaryFeedInput from './CalendarSummaryFeedInput';

import * as FeedState from '../../../state/reducer/feed/feed';

import Console from '../../../lib/debug';

class CalendarSummaryFeed extends Component {
    state = {
        deleteItem: false,
        showMore: false
    };

    deleteReplyCancel() {
        this.setState({
            deleteItem: null
        });
    }

    deleteReplyDialogOpen(reply) {
        this.setState({ deleteItem: reply });
    }

    deleteReplySubmit() {
        let deleteItem = this.state.deleteItem;

        this.setState({
            deleteItem: null
        });

        FeedState.deleteFeed(deleteItem, this.props.feedData.feedCard);
    }

    toggleLiked(feedItem, feedCardData) {
        if (feedItem) {
            feedItem.liked = !feedItem.liked;
        }
        if (feedItem && feedItem.liked) {
            feedItem.likesCount++;
        } else {
            feedItem.likesCount--;
        }
        FeedState.likeFeed(feedItem, feedCardData);
    }

    getReplyContainer(feedCard, reply, i) {
        let replyClass = reply.liked
            ? 'heroic icon-fist nudge active'
            : 'heroic icon-fist nudge';
        let likeText = reply.liked ? 'Unlike' : 'Like';
        let replyDelete =
            reply.isAuthor || feedCard.isCoach ? (
                <div className="feed-events">
                    <div>&bull;</div>
                    <IconButton
                        className="feed-button"
                        onClick={this.deleteReplyDialogOpen.bind(this, reply)}
                    >
                        Delete
                    </IconButton>
                </div>
            ) : null;

        let photoWrapper = null;
        if (reply.photo_url) {
            photoWrapper = (
                <div className="feed-photo-wrapper-drawer">
                    <img
                        className="feed-photo feed-photo-reply"
                        src={reply.photo_url}
                        alt=""
                    />
                </div>
            );
        }

        let replyCount = null;
        if (reply.likesCount > 0) {
            replyCount = (
                <span className="replies-count">&nbsp;{reply.likesCount}</span>
            );
        }

        return (
            <div className="parent-reply-container" key={'reply_' + i}>
                <div className="reply-container" key={i}>
                    <div className="reply-header">
                        <img
                            className="feed-profile-pic img-circle"
                            src={reply.profile_image}
                            alt=""
                        />
                    </div>
                    <div className="feed-response">
                        <div className="name-container">
                            <strong className="feed-title feed-athlete-name">
                                {reply.name}
                            </strong>
                        </div>
                        <span className="feed-content">{reply.content}</span>
                    </div>
                    {photoWrapper}
                </div>
                <div className="feed-events inline-feed-box">
                    <Button
                        variant="fab"
                        size="small"
                        className="punch-button"
                        onClick={this.toggleLiked.bind(this, reply, feedCard)}
                    >
                        <span className={replyClass} />
                        {replyCount}
                    </Button>
                </div>
                <div className="feed-events">
                    <span className="feed-time">{reply.time_since_post}</span>
                    <div>&bull;</div>
                    <IconButton
                        className="feed-button"
                        onClick={this.toggleLiked.bind(this, reply, feedCard)}
                    >
                        {likeText}
                    </IconButton>
                    {replyDelete}
                </div>
            </div>
        );
    }

    showMoreComments() {
        this.setState({
            showMore: !this.state.showMore
        });
    }

    render() {
        Console.render('CalendarSummaryFeed');

        let { feedData } = this.props;

        let showHideButton = null;
        let feedCard = feedData.feedCard;
        let feedCards = [];
        let moreCards = [];

        if (!feedCard) {
            return null;
        }

        let feedCardContainer = null;

        if (feedCard.replies && feedCard.replies.length > 0) {
            for (let i = 0; i < feedCard.replies.length; i++) {
                let reply = feedCard.replies[i];
                let replyItem = this.getReplyContainer(feedCard, reply, i);
                if (i <= 2) {
                    feedCards.push(replyItem);
                } else {
                    moreCards.push(replyItem);
                }
            }

            if (this.state.showMore && feedCard.replies.length > 3) {
                // moreCards = otherFeedThread;
                feedCards.push(moreCards);
                showHideButton = (
                    <Button
                        className="show-all-button"
                        onClick={this.showMoreComments.bind(this)}
                    >
                        Show fewer comments
                    </Button>
                );
            } else if (feedCard.replies.length > 3) {
                showHideButton = (
                    <Button
                        className="show-all-button"
                        onClick={this.showMoreComments.bind(this)}
                    >
                        Show all comments
                    </Button>
                );
            }

            feedCardContainer = (
                <div className="feed-container">
                    <div className="feed-thread-container">
                        <div className="main-feed-container">{feedCards}</div>
                    </div>
                    {showHideButton}
                </div>
            );
        }

        let classes = 'create-dialog create-edit-exercise-dialog';
        classes = classes + ' layout-column drawer-feed';

        return (
            <div className={classes}>
                <DialogFactory
                    enabled={!!this.state.deleteItem}
                    handleClose={this.deleteReplyCancel.bind(this)}
                    handleSave={this.deleteReplySubmit.bind(this)}
                    header="Delete Reply?"
                    text="Are you sure you want to delete this reply?"
                    cancelButtonTitle="Cancel"
                    saveButtonTitle="Delete"
                />

                {feedCardContainer}

                <CalendarSummaryFeedInput
                    feedData={feedData}
                    loggedInUser={this.props.loggedInUser}
                />
            </div>
        );
    }
}
export default CalendarSummaryFeed;
